export const StarOfMonthData = [
  {
    image: "https://lh3.googleusercontent.com/d/1m5zNikbeLTm_9MxbHYrHzCrk6I4liKe8=s1000?authuser=0",
    name: "Abdul Ahad",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1k17qEI1uY2BdfRctExMyfCRHWGTMSy02=s1000?authuser=0",
    name: "Anamta Fatima",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1k_WgKQQ22kxEnyOriJngQQNjYLguHltS=s1000?authuser=0",
    name: "Mariyam Yasir",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1vVUFNgxQ4uwuh1dWkgeRjLREJgb0kCC-=s1000?authuser=0",
    name: "Maha Adnan",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1Gcv05p9WFYgjqIWo-QKl1nYrKjrC0Dcp=s1000?authuser=0",
    name: "Muntaha Zainab",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1uQwwM_ZGLZheslCnbFa4C-eGVPEp-vLz=s1000?authuser=0",
    name: "Ansharah Imran",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1GzqsEwKVqmaVhoO_Dp0CSl_iuaKSTe6A=s1000?authuser=0",
    name: "Muhammad Zohan",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1JRoNN55YuNDCuIV4mNOoMrTNB2jxmirh=s1000?authuser=0",
    name: "Muhammad Affan",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/16hg1CASMmQcA_MHpUJSjo4qUp9EBjyLZ=s1000?authuser=0",
    name: "M Mujtaba Inam",
    date: "July, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1pCKWvpUI8RGui952udKo6qXiiyn7HtCN=s1000?authuser=0",
    name: "Muhammad",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1jn51DBCP0w23zFNxdwTdWrPThKl9SdQv=s1000?authuser=0",
    name: "M.khuzaima",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1mBIpZVvRfhBWpSm3TBQ6-jFm4O0QJkjp=s1000?authuser=0",
    name: "Musfirah",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1-TsYn07t0nsWBa1RzsoIs4p9qkUSptQK=s1000?authuser=0",
    name: "Rohan Ahmed",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1dW6uQ1646gaKIjg9w5ZVeR9DWseFaqjN=s1000?authuser=0",
    name: "Muhammad Hassan",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1ldBh0Z7I1zodsKkJYaVceHcYbz_IhZO8=s1000?authuser=0",
    name: "Aira irfan",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1-t1ZHp_84uw_zWQ-rHmHqVtxkiHdNbg7=s1000?authuser=0",
    name: "Rabail murtaza",
    date: "May, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1uA706mvHEjM75ESX8NLwS7sEuKcN0t5e=s1000?authuser=0",
    name: "Irha Khan",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1FoGTJUX3yTvCAZcObezU2A672BE9nOY0=s1000?authuser=0",
    name: "Muhammad Bin Ali",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1FnY47GrCC9vRyV8J5F6O91b-CLPe4D7R=s1000?authuser=0",
    name: "Muhammad tahoor",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1DUL3_A12P6AYW1k3HBNCu7Q1mp3NG0cw=s1000?authuser=0",
    name: "Affan Younus",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1y0vFDGxUDcsEpxN12ccPfLOuZMEtyC0g=s1000?authuser=0",
    name: "Murtajiz Hadi",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/118RiipTL6n9iIdAuLIZX-5N1Pu_lPfiK=s1000?authuser=0",
    name: "M. Shahwaiz khan",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1qXXMOqXE0NY63pxf04ZRbxL63LrQG4im=s1000?authuser=0",
    name: "Abdullah Mubashir",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1fonMzFpxExW229G1kmL3hS5U6og9lPpZ=s1000?authuser=0",
    name: "Muhammad",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1jIgShu4Kfph6XFJstHJSx9LePBKRM2mF=s1000?authuser=0",
    name: "M. Hussain Nawaz",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1e1WPEgk6sQkeffGYR9DZQXXzWT998rXm=s1000?authuser=0",
    name: "Fabiha Usman",
    date: "April, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1Knc6hCdIh_QJWeuCD7GJ5W6aZktHNEQk=s1000?authuser=0",
    name: "Muhammad Ismail Azeem",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1nJBZfnEAZdy7CI7rJSQKwDkNpgYjcDb1=s1000?authuser=0",
    name: "Eshal Fatima",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1jMzoeeR6hQecW4y4J4fYk3K9wpNhSDp7=s1000?authuser=0",
    name: "Wajiha Fatima",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1dvXHkWGTQGqu3cntmCsXy71JEeprbbxW=s1000?authuser=0",
    name: "Muhammad Bin Ali",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/10Dw7Ck0aguwce7x5mczcyLFvJtvSFURR=s1000?authuser=0",
    name: "Yumna Usman",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1j_7xnclfBjZOGAssXbJx1eMmkLsvVq6f=s1000?authuser=0",
    name: "Jaiden Yousaf",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1LKRpm8pMyUqVoR_eVVzSAkss5JqEJdwq=s1000?authuser=0",
    name: "Muhammad Tahoor",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1kt7j3nfxgWhVArHVBrZO-J3cZS53QJwE=s1000?authuser=0",
    name: "Irha Khan",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1yI0rfZLYlYx8wbz76ElRMIcBAuVW1wSi=s1000?authuser=0",
    name: "Hamna Basit",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1cnh3EnnNxGzwgH20fXrC8lRIRLB3ZF60=s1000?authuser=0",
    name: "Khubaib younus",
    date: "Feb, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1X5ie1PRqYsKkMTRAAyl0qoHZF5WnQTQ2=s1000?authuser=0",
    name: "Muhammad bin Umer",
    date: "Jan, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1xoNsEWYhCvShA4_WXBvsDCdtBwNQqSSz=s1000?authuser=0",
    name: "Muhammad Tahoor",
    date: "Jan, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1SiaZzlpuzGT9HOFErdXxia-W-iu2cmZt=s1000?authuser=0",
    name: "Muhammad Zohan",
    date: "Jan, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1Ed9C4Cc-3AWaLVKCexkasTA8fuK0uLcI=s1000?authuser=0",
    name: "Muhammad bin Ali",
    date: "Jan, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1U-d7jJ0y1lYjFfeeFPZ9Osn9QDC71XMx=s1000?authuser=0",
    name: "Ayesha Salman",
    date: "Jan, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1Ni3qLLxjrCeIppknIWhQFAuhtrYSM-z6=s1000?authuser=0",
    name: "Abdul Hadi",
    date: "Jan, 2025"
  },
  {
    image: "https://lh3.googleusercontent.com/d/1iX3gKSmvyGH2qOJJk6Rx2edpxQu2dK6B=s1000?authuser=0",
    name: "Fatima Adil",
    date: "Jan, 2025"
  },
]